import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discrepancy',
  templateUrl: './discrepancy.component.html',
  styleUrls: ['./discrepancy.component.scss'],
})
export class DiscrepancyComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
